import { type FC } from "react";
import { Heading } from "@root/shared/components/Heading";
import { PublicationArticleContainer } from "@clientFrontend/features/publication/components/PublicationArticleContainer";
import { BrandContentDetail } from "@clientFrontend/features/publication/components/BrandContentDetail";
import * as styles from "./styles.css";

type Image = {
  id: number;
  src: string;
};

type BrandContent = {
  name: string;
  logoImage: Image;
  clientImage: Image;
  concept: string;
};

type Props = {
  brandContent: BrandContent;
  site: "biyo" | "kaigo";
};

export const BrandContentShow: FC<Props> = ({ brandContent, site }) => {
  return (
    <PublicationArticleContainer>
      <Heading tag="h1" size="xLarge" bold className={styles.pageTitle}>
        ブランド情報詳細
      </Heading>
      <BrandContentDetail brandContent={brandContent} site={site} />
    </PublicationArticleContainer>
  );
};
